import SVGInject from '@iconfu/svg-inject'

SVGInject.setOptions({
	useCache: false,
	makeIdsUnique: false,
});

SVGInject(document.querySelectorAll('img.svg-inject'));